export default __webpack_public_path__ + "static/media/cont7.f0a1fa92.jpg";